import {
  actionCreator,
  checkHttpStatus,
  createRequestActionTypes,
  jsonApiHeader,  
  API_URL
} from '../../../actions/utilAction';

export {
  actionCreator,
  jsonApiHeader,
  checkHttpStatus,
  API_URL,
};

export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const GET_STAFF_BYLOCATION = `${API_URL}/api/PatientAppointments/GetStaffByLocation`;
export const GET_PATIENT = `${API_URL}/api/PatientAppointments/GetStaffAndPatientByLocation`;
export const GET_HAS_URLACCESS = `${API_URL}/api/RolePermission/HasUrlAccess`;
export const GET_PATIENTLIST = `${API_URL}/api/PatientAppointments/GetPatientByLocationWithExcludeFullyPaid`;
export const GET_PATIENTLIST_WITHPERMISSION = `${API_URL}/api/PatientAppointments/GetPatientByLocationWithPermission`;
export const GET_REPORTSBYTYPECATEGORY = `${API_URL}/User/GetReportsByTypeCategory`;
export const GET_PATIENT_BY_LACARE = `${API_URL}/api/PatientAppointments/GetLACarePatientByLocation`;

export const reportActionTypes = {  
  get_masterdata: createRequestActionTypes('GET_MASTERSDATA'),
  get_Staff_ByLocation: createRequestActionTypes('GET_STAFF_BYLOCATION'),
  get_patient: createRequestActionTypes('GET_PATIENT'),
  get_hasurlaccess: createRequestActionTypes('GET_HAS_URLACCESS'),
  get_reportsbytypecategory: createRequestActionTypes('GET_REPORTSBYTYPECATEGORY'),  
};




// WEBPACK FOOTER //
// ./src/modules/Reports/constants/ApiContants.js